// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".landing-credits_footer{padding:56px 96px 76px 98px;background-color:#404040;font-style:normal;font-weight:normal;font-size:14px;color:#959595}.landing-credits_footer>p>a{color:#959595;text-decoration:underline}@media only screen and (max-width: 767px){.landing-credits_footer{padding:24px 20px}}.landing-credits_text{line-height:20px}.landing-credits_text>p>a{color:#959595;text-decoration:underline}@media(max-width: 1940px){.landing-credits_text>br{display:none}}", ""]);
// Exports
module.exports = exports;
